/**
 * @generated SignedSource<<551583e38216e238d2078dbef337bd71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegenerateTicketAiSummaryInput = {
  ticketId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type regenerateTicketAiSummaryMutation$variables = {
  input: RegenerateTicketAiSummaryInput;
};
export type regenerateTicketAiSummaryMutation$data = {
  readonly regenerateTicketAiSummary: {
    readonly clientMutationId: string | null;
    readonly ticket: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AiSummaryBlock_ticket" | "AiSuggestedActionsList_ticket">;
    };
  } | null;
};
export type regenerateTicketAiSummaryMutation = {
  variables: regenerateTicketAiSummaryMutation$variables;
  response: regenerateTicketAiSummaryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "regenerateTicketAiSummaryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegenerateTicketAiSummaryPayload",
        "kind": "LinkedField",
        "name": "regenerateTicketAiSummary",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ticket",
            "kind": "LinkedField",
            "name": "ticket",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AiSummaryBlock_ticket"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AiSuggestedActionsList_ticket"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "regenerateTicketAiSummaryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegenerateTicketAiSummaryPayload",
        "kind": "LinkedField",
        "name": "regenerateTicketAiSummary",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Ticket",
            "kind": "LinkedField",
            "name": "ticket",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiSummaryState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiSummaryRefusalMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketAiSummary",
                "kind": "LinkedField",
                "name": "aiSummary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusSignal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentiment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "generatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modelVersion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "feedbackScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "feedbackText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFinal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketAiSummaryStaleness",
                    "kind": "LinkedField",
                    "name": "staleness",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isStale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newComments",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newEmails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newStatusEvents",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketAiSuggestedAction",
                "kind": "LinkedField",
                "name": "aiSuggestedActions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "suggestedDueDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rationale",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "confidence",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "initials",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f456ff49f617bca260303b45adf3039c",
    "id": null,
    "metadata": {},
    "name": "regenerateTicketAiSummaryMutation",
    "operationKind": "mutation",
    "text": "mutation regenerateTicketAiSummaryMutation(\n  $input: RegenerateTicketAiSummaryInput!\n) {\n  regenerateTicketAiSummary(input: $input) {\n    clientMutationId\n    ticket {\n      id\n      ...AiSummaryBlock_ticket\n      ...AiSuggestedActionsList_ticket\n    }\n  }\n}\n\nfragment AiSuggestedActionsList_ticket on Ticket {\n  id\n  status\n  aiSummary {\n    generatedAt\n    isFinal\n  }\n  aiSuggestedActions {\n    id\n    title\n    suggestedDueDate\n    rationale\n    confidence\n    status\n    assignee {\n      id\n      fullName\n      initials\n      profilePictureId\n      active\n      ...ticketingPerson_person\n    }\n  }\n}\n\nfragment AiSummaryBlock_ticket on Ticket {\n  id\n  status\n  aiSummaryState\n  aiSummaryRefusalMessage\n  aiSummary {\n    summary\n    statusSignal\n    sentiment\n    commentCount\n    emailCount\n    generatedAt\n    modelVersion\n    feedbackScore\n    feedbackText\n    isFinal\n    staleness {\n      isStale\n      newComments\n      newEmails\n      newStatusEvents\n      total\n    }\n  }\n  aiSuggestedActions {\n    id\n    title\n    suggestedDueDate\n    rationale\n    confidence\n    status\n    assignee {\n      id\n      fullName\n      initials\n      profilePictureId\n      active\n      ...ticketingPerson_person\n    }\n  }\n}\n\nfragment ticketingPerson_person on Person {\n  id\n  firstName\n  lastName\n  fullName\n  initials\n  profilePictureId\n  active\n}\n"
  }
};
})();

(node as any).hash = "6ce4b5784c67f2293f9483129d6ef3d9";

export default node;
